/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { AppConfiguration } from './app/types/app-configuration';
import { initializeDataDog } from './app/config/data-dog.config';
import { appConfigFactory } from './app/config/app.config';

fetch('assets/configuration/app-configuration.json')
  .then(res => res.json() as Promise<AppConfiguration>)
  .then(config => {
    if (config.production) {
      enableProdMode();
      initializeDataDog(config);
    }
    bootstrapApplication(AppComponent, appConfigFactory(config)).catch((err) => console.error(err));
  });
